import { createContext, PropsWithChildren, useContext, useState } from 'react'
import { StepperContextValue, StepperProviderProps } from './Types'
import { NOOP } from 'utils'

const StepperContext = createContext<StepperContextValue>({
  step: 0,
  steps: 0,
  stepBackward: NOOP,
  stepForward: NOOP,
})

export const StepperProvider = ({
  children,
  initialStep = 1,
  steps,
  onStepChange,
}: PropsWithChildren<StepperProviderProps>) => {
  const [step, setStep] = useState(Math.max(1, Math.min(initialStep, steps)))

  const value = {
    step,
    steps,
    stepForward: () => {
      setStep((step) => {
        const newStep = Math.min(steps, step + 1)
        onStepChange?.(newStep)
        return newStep
      })
    },
    stepBackward: () => {
      setStep((step) => {
        const newStep = Math.max(1, step - 1)
        onStepChange?.(newStep)
        return newStep
      })
    },
  }

  return <StepperContext.Provider value={value}>{children}</StepperContext.Provider>
}

export const useStepper = () => useContext(StepperContext)
